import { render, staticRenderFns } from "./result_zk_suc_comn.vue?vue&type=template&id=f36403c2&scoped=true"
import script from "./result_zk_suc_comn.vue?vue&type=script&lang=js"
export * from "./result_zk_suc_comn.vue?vue&type=script&lang=js"
import style0 from "./result_zk_suc_comn.vue?vue&type=style&index=0&id=f36403c2&prod&lang=scss&scoped=true"
import style1 from "./result_zk_suc_comn.vue?vue&type=style&index=1&id=f36403c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36403c2",
  null
  
)

export default component.exports